module.exports = __webpack_public_path__ + "db8c361a332c35d3fde5e737808cf1d2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/backpack-s.png
// module id = 1796
// module chunks = 0